//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { addResizeListener, removeResizeListener } from 'element-ui/src/utils/resize-event';
export default {
  name: 'd2-scrollbar',
  inheritAttrs: false,
  mounted: function mounted() {
    var scrollbar = this.$refs.scrollbar;
    addResizeListener(scrollbar.$el, scrollbar.update);
    this.$once('hook:beforeDestroy', function () {
      removeResizeListener(scrollbar.$el, scrollbar.update);
    });
  }
};